import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'localizedDate',
  pure: false,
  standalone: true
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: any, showTime: boolean = false, customFormat?: string): string | null {
    const lang = this.translate.currentLang;

    const dateOnlyFormats: { [key: string]: string } = {
      'en-US': 'MM/dd/yy',
      'en-GB': 'dd/MM/yy',
      'es': 'dd/MM/yy',
      'fi': 'dd.MM.yy',
      'sv': 'yy-MM-dd',
      'no': 'dd.MM.yy',
      'it': 'dd/MM/yy',
      'ae': 'dd/MM/yy',
      'pt': 'dd/MM/yy',
    };

    const dateTimeFormats: { [key: string]: string } = {
      'en-US': "MM/dd/yy 'at' h:mma",
      'en-GB': "dd/MM/yy 'at' h:mma",
      'es': "dd/MM/yy 'a las' h:mma",
      'fi': "dd.MM.yy 'klo' H:mm",
      'sv': "yy-MM-dd 'kl' H:mm",
      'no': "dd.MM.yy 'kl' H:mm",
      'it': "dd/MM/yy 'alle' H:mm",
      'ae': "dd/MM/yy 'الساعة' h:mma",
      'pt': "dd/MM/yy 'às' H:mm",
    };

    const formatMap = showTime ? dateTimeFormats : dateOnlyFormats;
    const format = customFormat?.trim() || formatMap[lang] || (showTime ? 'medium' : 'shortDate');

    return new DatePipe(lang).transform(value, format);
  }
}
